<template>
  <iframe
    v-if="src"
    ref="metabase"
    :src="src"
    width="100%"
    height="100%"
    frameborder="0"
    allowtransparency
  ></iframe>
  <div v-else-if="loading" class="loading-container">
    <i class="el-icon-loading"></i>
  </div>
  <div v-else-if="error" class="error-container">
    {{ error }}
  </div>
</template>

<script>
import RestApi from '@/core/services/RestApi'
import { projectEndpoint } from '@/core/helpers'

export default {
  name: 'MetabaseApplication',

  props: {
    projectId: {
      required: false
    }
  },

  data() {
    return {
      src: null,
      loading: true,
      error: null
    }
  },

  mounted() {
    this.initialize()

    window.addEventListener('message', e => {
      if (e.data.metabase) {
        if (e.data.metabase.type === 'location') {
          const { pathname, hash } = e.data.metabase.location
          window.history.pushState(
            null,
            '',
            this.buildRedirectUrl(pathname, hash)
          )
        }
      }
    })
  },

  methods: {
    initialize() {
      this.loading = true
      this.error = null

      const needsMetadata = this.projectId && this.$route.query.manage
      const metadataPromise = needsMetadata
        ? RestApi(projectEndpoint({ method: 'get', url: 'metabase/metadata' }))
        : Promise.resolve(null)

      const tokenEndpoint = this.projectId
        ? projectEndpoint({ method: 'get', url: 'metabase/token' })
        : { method: 'get', url: 'metabase/token' }
      const tokenPromise = RestApi(tokenEndpoint)

      Promise.all([tokenPromise, metadataPromise])
        .then(([tokenResponse, metadataResponse]) => {
          let path = null
          if (metadataResponse && metadataResponse.data) {
            const collectionId =
              metadataResponse.data.published_dashboards_collection_id
            if (collectionId) {
              path = '/collection/' + collectionId
            }
          }
          this.src = this.buildSrc(tokenResponse.data.token, path)
        })
        .catch(err => {
          this.error = err.message || 'Failed to load Metabase'
        })
        .finally(() => {
          this.loading = false
        })
    },

    buildRedirectUrl(pathname, hash) {
      let url

      if (this.projectId) {
        url = '/metabase/project?project_id=' + this.projectId + '&'
      } else {
        url = '/metabase?'
      }

      url += 'path=' + encodeURIComponent(pathname)

      if (hash) {
        url += '&hash=' + encodeURIComponent(hash)
      }

      return url
    },

    buildSrc(jwt, defaultPath) {
      let url = this.$route.query.path || defaultPath || '/'

      url += '?side_nav=true&top_nav=true&search=true&new_button=true'

      if (this.$route.query.hash) {
        url += this.$route.query.hash
      }

      return (
        window.xp.metabaseUrl +
        '/auth/sso?jwt=' +
        encodeURIComponent(jwt) +
        '&return_to=' +
        encodeURIComponent(url)
      )
    }
  },

  watch: {
    '$route.query.path': {
      handler: function(path) {
        if (this.$refs['metabase']) {
          this.$refs['metabase'].contentWindow.postMessage(
            {
              metabase: {
                type: 'location',
                location: path
              }
            },
            // FIXME SECURITY: use whitelisted origin instead of "*"
            '*'
          )
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style scoped>
iframe {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.loading-container,
.error-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 24px;
}

.error-container {
  color: #f56c6c;
}
</style>



// WEBPACK FOOTER //
// src/modules/metabase/pages/MetabaseApplication.vue